import { EnvMicroDocument } from 'lib-klab-core';

export const envDocumentLocal: EnvMicroDocument = {
  host: '',
  apiBasePath: '/api/v1/s3',
};

export const envDocumentDev: EnvMicroDocument = {
  host: 'https://gatewayapi-dev.klab.inclub.world',
  apiBasePath: '/ms-document/api/v1/s3',
  mediaAllowedOrigins: ['https://klab-erp.s3.us-east-2.amazonaws.com'],
  mediaWriteMode: 'receipt-required',
  allowLegacyMediaKeys: false,
};

export const envDocumentProd: EnvMicroDocument = {
  host: 'https://gatewayapi.klab.inclub.world',
  apiBasePath: '/ms-document/api/v1/s3',
  mediaAllowedOrigins: ['https://klab-erp.s3.us-east-2.amazonaws.com'],
  mediaWriteMode: 'receipt-required',
  allowLegacyMediaKeys: false,
};
